/**
 * The visitor's answer to the cookie banner, kept on their own device.
 *
 * Remembering the answer is the one thing stored before they give it: without
 * it the banner would ask again on every page. Raising the version asks
 * everyone again, which is what a new tool on the list needs.
 */
import { ref } from 'vue'

const KEY = 'consent'
const VERSION = 1

// Note: names the analytics tools set on Bindle's own domain, cleared when a visitor withdraws
const ANALYTICS_STORAGE_PREFIX_LIST = ['_ga', '_gid', '_gcl', '_fbp', '_fbc', '_lo', 'ph_']

function stored() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY))

    return value?.version === VERSION ? value : null
  } catch {
    return null
  }
}

export const consent = ref(stored())
export const consentBannerOpen = ref(consent.value === null)

export function consentDecide(analytics) {
  const withdrawn = consent.value?.analytics === true && !analytics

  consent.value = { analytics, at: new Date().toISOString(), version: VERSION }
  localStorage.setItem(KEY, JSON.stringify(consent.value))
  consentBannerOpen.value = false

  // Note: a tool already running cannot be unloaded, so the page starts again without it
  if (withdrawn) {
    analyticsStorageClear()
    window.location.reload()
  }
}

export function consentBannerReopen() {
  consentBannerOpen.value = true
}

function analyticsStorageClear() {
  const matches = name => ANALYTICS_STORAGE_PREFIX_LIST.some(prefix => name.startsWith(prefix))
  const hostParts = window.location.hostname.split('.')
  const domainList = hostParts.map((_, index) => hostParts.slice(index).join('.'))

  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0].trim()

    if (!matches(name)) {
      continue
    }
    document.cookie = `${name}=; Max-Age=0; path=/`
    for (const domain of domainList) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${domain}`
    }
  }

  for (const name of Object.keys(localStorage)) {
    if (matches(name)) {
      localStorage.removeItem(name)
    }
  }
}
